// extracted by mini-css-extract-plugin
export default {"exitBlock":"QuizExitButton_exitBlock__s3BI1","exitIcon":"QuizExitButton_exitIcon__APV+E"};